import { render, staticRenderFns } from "./deliveryListing.vue?vue&type=template&id=52c7630a&"
import script from "./deliveryListing.vue?vue&type=script&lang=js&"
export * from "./deliveryListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports